import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ShieldCheck, Loader2 } from "lucide-react";
import { api, formatApiErrorDetail } from "../../lib/api";
import { useAuth } from "../../lib/auth";
import { t } from "../../lib/portalI18n";

export default function PortalInvite() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { acceptPortalInvite } = useAuth();
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const lang = info?.lang || "nl";
  useEffect(() => { api.get(`/portal/invite/${token}`).then((r) => setInfo(r.data)).catch((e) => setErr(formatApiErrorDetail(e?.response?.data?.detail) || t("nl", "invalid"))); }, [token]);
  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) { setErr(t(lang, "mismatch")); return; }
    setBusy(true); setErr("");
    try { await acceptPortalInvite(token, pw, lang); navigate("/portal", { replace: true }); } catch (ex) { setErr(formatApiErrorDetail(ex?.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-[#0f1c17] text-white flex items-center justify-center p-5" data-testid="portal-invite-page">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2 text-emerald-300 text-xs uppercase tracking-[0.2em] mb-6"><ShieldCheck size={14} /> Playmaker · {t(lang, "read_only")}</div>
        {err && !info && <div className="text-sm text-rose-300" data-testid="portal-invite-error">{err}</div>}
        {info && (
          <form onSubmit={submit} className="space-y-4">
            <div><div className="text-white/60 text-sm">{t(lang, "invite_for")}</div><h1 className="text-2xl font-semibold leading-tight" data-testid="portal-invite-title">{info.name}</h1><div className="text-white/60 text-sm mt-1">{info.relation === "guardian" ? `${t(lang, "guardian_of")} ${info.client_name}` : info.client_name} · {info.email}</div></div>
            <label className="block text-sm"><span className="text-white/70">{t(lang, "set_password")}</span><input type="password" minLength={8} required value={pw} onChange={(e) => setPw(e.target.value)} placeholder={t(lang, "password")} className="mt-1 w-full h-12 rounded-xl bg-white/10 border border-white/15 px-4 text-white placeholder:text-white/40 focus:outline-none focus:ring-2 focus:ring-emerald-400" data-testid="portal-invite-password" /></label>
            <input type="password" minLength={8} required value={pw2} onChange={(e) => setPw2(e.target.value)} placeholder={t(lang, "repeat")} className="w-full h-12 rounded-xl bg-white/10 border border-white/15 px-4 text-white placeholder:text-white/40 focus:outline-none focus:ring-2 focus:ring-emerald-400" data-testid="portal-invite-password2" />
            {err && <div className="text-sm text-rose-300" data-testid="portal-invite-error">{err}</div>}
            <button type="submit" disabled={busy} className="w-full h-12 rounded-xl bg-emerald-500 text-[#0f1c17] font-semibold flex items-center justify-center gap-2 disabled:opacity-60 active:scale-[0.99] transition-transform" data-testid="portal-invite-submit">{busy && <Loader2 size={16} className="animate-spin" />} {t(lang, "open_portal")}</button>
          </form>
        )}
      </div>
    </div>
  );
}
